module.exports = __webpack_public_path__ + "img/external-link.4032e99b.svg";